import React, { useState, useEffect, useContext } from "react";
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper,
    Button,
} from "@mui/material";
import {
    ModeEditOutlineOutlined,
} from "@mui/icons-material";
import AsyncSelect from "react-select/async";
import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import toast from "react-hot-toast";
import blogFetch from "../../../../axios/config";
import { DateTimeFmt } from "../../../../utils/DataUtils";
import { useNavigate } from 'react-router-dom';
import { IGSA } from "../GSAModal";
import { getCookie } from "../../../../section/cookie";
import { BI_TAB_Perdas } from "../../../Apontamento/Types";


const INITIAL_MODAL = {
    isShow: false,
    title: "",
    body: ""
}

interface IDefeitoGSA {
    defeito_Key: number;
    defeito_Descricao: string;
    defeito_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

interface IDefeitoGSA {
    defeito_Key: number;
    defeito_Descricao: string;
    defeito_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

interface ISAGA_OrdensProducao {
    ordem_Part_Short: string;
    ordem_VehDesc: string;
    ordem_SetAtual: string;
}

interface IGSAList {
    gsA_Key: number;
    gsA_Ordem: string;
    gsA_Status: string;
    gsA_Defeito_Key: number;
    defeito: IDefeitoGSA | null;
    informacoes: ISAGA_OrdensProducao
    gsA_DataEntrada: string;
    _Mod: string | null;
    _Creat: string;
    _ts_Creat: string;
    _ts_Mod: string | null;
    setorRetrabalho?: ISetorRetrabalho;
    gsA_DataFinalizacao: string | null;
    molde_Key: number | null;
    molde_Lote: string | null;
    hasRefugo: boolean;
    hasPendency: boolean;
}

interface ISetorRetrabalho {
    setor_Key: number;
    setor_Ativo: boolean;
    setor_Descricao: string;
    _ts_Creat: string;
    _Creat: string;
    _ts_Mod: null;
    _Mod: null;
}

interface IiSAGA_Setores_Retrabalho_GSA {
    setor_Key: number;
    setor_Descricao: string;
    setor_Ativo: boolean;
    _Mod: string;
    _ts_Mod: Date;
}

interface IMoldePendenciaMotivo {
    molde_Pend_Mot_Key: number;
    molde_Pend_Mot_Descricao: string;
    molde_Pend_Mot_Ativo: boolean;
    molde_Pend_Mot_Responsavel: string;
    _Creat: string;
    _ts_Creat: string;
    _Mod: string | null;
    _ts_Mod: string | null;
}

function GSAList({ }) {
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<IGSAList[]>([]);
    const [isGetPendencias, setIsGetPendencias] = useState(false);
    // const [showModal, setShowModal] = useState(INITIAL_MODAL);
    const [updatePendancy, setUpdatePendancy] = useState({});
    const [sectorStates, setSectorStates] = useState({ name: "" });
    const [selectedItem, setSelectedItem] = useState<IGSAList | null>(null);
    const [showModal, setShowModal] = useState(false);
    const [showApproveModal, setShowApproveModal] = useState(false);
    const [showReprocessoModal, setShowReprocessoModal] = useState(false);
    const [showReprocessoToAnalysisModal, setShowReprocessoToAnalysisModal] = useState(false);
    const [reprocessoToAnalysisLoading, setReprocessoToAnalysisLoading] = useState(false);
    const [showModalAppointment, setShowModalAppointment] = useState(false);
    const [sectors, setSectors] = useState<IiSAGA_Setores_Retrabalho_GSA[]>([]);
    const [sector, setSector] = useState("");

    const [defects, setDefects] = useState<IDefeitoGSA[]>([]);
    const [defect, setDefect] = useState("");
    const [ordemFilter, setOrdemFilter] = useState("");
    const [showMoldeModal, setShowMoldeModal] = useState(false);
    const [moldeData, setMoldeData] = useState<BI_TAB_Perdas[]>([]);
    const [moldeLoading, setMoldeLoading] = useState(false);
    const [moldeMotivos, setMoldeMotivos] = useState<IMoldePendenciaMotivo[]>([]);
    const [moldeMotivo, setMoldeMotivo] = useState("");
    const cookie = getCookie("permissions");
    const gsaClaimButtons = cookie?.includes("[GSA] - Tela refugo");
    const gsaMoldButton = cookie?.includes("[GSA] - Moldes");


    const navigate = useNavigate();
    const user = JSON.parse(localStorage.getItem('user') || '{}');

    const getDefectsList = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get`);
            setDefects(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const handleOpenModal = (item: IGSAList) => {
        setSelectedItem(item);
        setDefect(item.defeito?.defeito_Key ? String(item.defeito.defeito_Key) : "");
        setShowModal(true);
    };

    const handleOpenApproveModal = (item: IGSAList) => {
        setSelectedItem(item);
        setShowApproveModal(true);
    };

    const handleCloseApproveModal = () => {
        setSelectedItem(null);
        setShowApproveModal(false);
    };

    const handleOpenAppointmentModal = (item: IGSAList) => {
        setSelectedItem(item);
        setShowModalAppointment(true);
    };

    const handleOpenMoldeModal = async (item: IGSAList) => {
        try {
            setMoldeLoading(true);
            setSelectedItem(item);
            const response = await blogFetch.get(`Loss/validate-forno/${item.gsA_Ordem}`);
            if (response.data.success) {
                setMoldeData(response.data.data as BI_TAB_Perdas[]);
                setShowMoldeModal(true);

                try {
                    const motivosResponse = await blogFetch.get(`/ISAGA_MoldePendenciasMotivo`);
                    const ativos = (motivosResponse.data as IMoldePendenciaMotivo[]).filter(m => m.molde_Pend_Mot_Ativo);
                    setMoldeMotivos(ativos);
                } catch (motivoError: any) {
                    setMoldeMotivos([]);
                    toast.error(motivoError?.response?.data?.message ?? "Erro ao buscar motivos de pendência.");
                }
            } else {
                toast.error(response.data.message ?? "Erro ao buscar dados do molde.");
            }
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Erro ao buscar dados do molde.");
        } finally {
            setMoldeLoading(false);
        }
    };

    const handleCloseMoldeModal = () => {
        setShowMoldeModal(false);
        setMoldeData([]);
        setMoldeMotivo("");
        setMoldeMotivos([]);
    };

    const disableMolde = async () => {
        if (!selectedItem || !moldeMotivo) return;

        try {
            setMoldeLoading(true);

            if (!selectedItem.molde_Key) {
                toast.error("Molde não identificado para esta ordem.");
                return;
            }

            const payload = {
                Molde_Key: selectedItem.molde_Key,
                Molde_Pend_Status: "ABERTO",
                Molde_Pend_Mot_Key: Number(moldeMotivo),
                Molde_Pend_Obs: ""
            };

            const response = await blogFetch.post(`/ISAGA_MoldePendencias`, payload);
            if (response.data?.success ?? response.status === 200) {
                toast.success(response.data?.message ?? "Molde enviado para ferramentaria com sucesso!");
                handleCloseMoldeModal();
            } else {
                toast.error(response.data?.message ?? "Erro ao enviar molde para a ferramentaria ou molde já esta com pendência.");
            }
            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Erro ao enviar molde para a ferramentaria ou molde já esta com pendência.");
        } finally {
            setMoldeLoading(false);
        }
    };

    const getSectors = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get/sectors`);
            setSectors(response.data);

        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const gotoLoss = (item: IGSAList) => {
        const params = new URLSearchParams({
            gsaOrder: item.gsA_Ordem,
            gsaSector: item.informacoes.ordem_SetAtual
        });
        navigate(`/Apontamento_SAP?${params.toString()}`);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        setSelectedItem(null);
        setDefect("");
    };

    const getDefects = async () => {
        try {
            setLoading(true);
            const response = await blogFetch.get(`/DefectsGSA/get/list`);
            setData(response.data.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        async function fetchData() {
            await getDefects();
            await getSectors();
            await getDefectsList();
        }
        fetchData();
    }, [])




    const reworkGSA = async (selectedItem: IGSAList) => {
        try {

            if (!defect) {
                toast.error("Selecione o defeito!");
                return;
            }

            if (selectedItem.gsA_Status == "Em analise") {
                if (!sector) {
                    toast.error("Selecione o setor de retrabalho!");
                    return;
                }
                var status2 = "RETRABALHO"
            }
            else
                var status2 = "Em analise"

            const gsa: IGSA = {
                GSA_Ordem: selectedItem.gsA_Ordem,
                GSA_Status: status2,
                GSA_Defeito_Key: Number(defect),
                GSA_SetorRetrabalho_Key: Number(sector) ?? null,
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            const response = await blogFetch.post(`/DefectsGSA/rework`, gsa);
            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            handleCloseModal();
            setSector("");
            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        }
    };

    const approveGSA = async (selectedItem: IGSAList) => {
        try {

            const gsa: IGSA = {
                GSA_Ordem: selectedItem.gsA_Ordem,
                GSA_Status: "LIBERADA",
                GSA_Defeito_Key: null,
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            const response = await blogFetch.post(`/DefectsGSA/approve`, gsa);
            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            handleCloseApproveModal();

            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        }
    };

    const reprocessoToAnalysis = async (selectedItem: IGSAList) => {
        try {
            setReprocessoToAnalysisLoading(true);
            const gsa: IGSA = {
                GSA_Ordem: selectedItem.gsA_Ordem,
                GSA_Status: "Em analise",
                GSA_Defeito_Key: selectedItem.gsA_Defeito_Key,
                _Creat: user.user_UserName ?? user.user_Matricula
            };
            const response = await blogFetch.post(`/DefectsGSA/reject-reprocesso`, gsa);
            if (response.data.success) {
                toast.success(response.data.message);
            } else {
                toast.error(response.data.message);
            }
            setShowReprocessoToAnalysisModal(false);
            setSelectedItem(null);
            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        } finally {
            setReprocessoToAnalysisLoading(false);
        }
    };

    const confirmReprocesso = async (selectedItem: IGSAList) => {
        try {
            const response = await blogFetch.put(`/Loss/confirm-reprocesso/${selectedItem.gsA_Ordem}`);
            if (response.data?.success) {
                toast.success(response.data.message ?? "Reprocesso confirmado com sucesso!");
            } else {
                toast.error(response.data?.message ?? "Erro ao confirmar reprocesso.");
            }
            setShowReprocessoModal(false);
            setSelectedItem(null);
            await getDefects();
        } catch (error: any) {
            toast.error(error?.response?.data?.message ?? "Ocorreu um erro inesperado. Tente novamente.");
        }
    };

    const tableList = ((filter: string) => {
        return <><Table>
            <TableHead>
                <TableRow style={{ backgroundColor: "#f5f5f5" }}>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Ordem
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Peça
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Defeito
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Veiculo
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Setor
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Status
                    </TableCell>
                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Hora Entrada
                    </TableCell>

                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Horas Paradas
                    </TableCell>

                    {filter == "RETRABALHO" &&
                        (
                            <>
                                <TableCell
                                    align="center"
                                    className="row-header"
                                >
                                    Setor Retrabalho
                                </TableCell>
                            </>
                        )
                    }

                    <TableCell
                        align="center"
                        className="row-header"
                    >
                        Acoes
                    </TableCell>
                </TableRow>
            </TableHead>
            {loading ? (
                <TableBody>
                    <TableRow>
                        <div className="d-flex justify-content-center align-items-center"
                            style={{ margin: "30px 0px" }}
                        >
                            <center>
                                <FontAwesomeIcon icon={faSpinner} spin size="2x" />
                            </center>
                        </div>
                    </TableRow>
                </TableBody>
            ) : (
                <TableBody>
                    {data.length
                        ? data.filter(x => x.gsA_Status == filter && (ordemFilter === "" || x.gsA_Ordem.toLowerCase().includes(ordemFilter.toLowerCase()))).map((item, index) => (
                            <TableRow key={index} >
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                    align="center"
                                >
                                    {item.gsA_Ordem}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes?.ordem_Part_Short}

                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                    align="center"
                                >
                                    {item.defeito?.defeito_Descricao}
                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes?.ordem_VehDesc}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.informacoes?.ordem_SetAtual}
                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {item.gsA_Status}
                                </TableCell>

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {DateTimeFmt(item.gsA_DataEntrada)}

                                </TableCell>
                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {Math.floor((new Date().getTime() - new Date(item.gsA_DataEntrada).getTime()) / (1000 * 60 * 60))}h

                                </TableCell>

                                {filter == "RETRABALHO" &&
                                    (
                                        <>
                                            <TableCell
                                                align="center"
                                                className="row-header"
                                            >
                                                {item.setorRetrabalho?.setor_Descricao ?? ""}
                                            </TableCell>
                                        </>
                                    )
                                }

                                <TableCell
                                    className="row-header"
                                    sx={{ whiteSpace: "nowrap", textAlign: "center" }}
                                >
                                    {gsaClaimButtons && (
                                        filter === "REPROCESSO" ? (
                                            <>
                                                <button
                                                    onClick={() => { setSelectedItem(item); setShowReprocessoToAnalysisModal(true); }}
                                                    type="button"
                                                    className="btn btn-sm btn-primary me-2"
                                                >
                                                    Em analise
                                                </button>
                                                <button
                                                    onClick={() => { setSelectedItem(item); setShowReprocessoModal(true); }}
                                                    type="button"
                                                    className="btn btn-sm btn-success"
                                                >
                                                    Liberar
                                                </button>
                                            </>
                                        ) : (
                                            <>
                                                <button
                                                    onClick={() => handleOpenModal(item)}
                                                    type="button"
                                                    className={`btn btn-sm ${item.gsA_Status == "Em analise" ? "btn-warning" : "btn-primary"} me-2`}
                                                >
                                                    {item.gsA_Status == "Em analise" ? "Retrabalho" : "Em analise"}
                                                </button>
                                                <button
                                                    onClick={() => gotoLoss(item)}
                                                    type="button"
                                                    className="btn btn-sm btn-danger me-2"
                                                >
                                                    Apontar perda
                                                </button>
                                                <button
                                                    onClick={() => handleOpenApproveModal(item)}
                                                    type="button"
                                                    className="btn btn-sm btn-success"
                                                >
                                                    Liberar
                                                </button>
                                                {(filter === "Em analise" && gsaMoldButton) && (
                                                    <button
                                                        onClick={() => handleOpenMoldeModal(item)}
                                                        type="button"
                                                        className="btn btn-sm btn-info ms-2"
                                                        disabled={moldeLoading || item.hasPendency || item.molde_Lote === null}
                                                    >
                                                        Molde
                                                    </button>
                                                )}
                                            </>
                                        )
                                    )}

                                </TableCell>
                            </TableRow>
                        ))
                        : (
                            <TableRow>
                                <TableCell
                                    className="row-header"
                                    sx={{ textAlign: "center" }}
                                    rowSpan={5}
                                >
                                    Nao encontrado
                                </TableCell>
                            </TableRow>
                        )}
                </TableBody>
            )}
        </Table>
        </>
    })

    return (

        <>

            {showModal && selectedItem &&
                (
                    <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h1 className="modal-title fs-5">

                                        {selectedItem.gsA_Status == "Em analise" ? "RETRABALHO" : "EM ANALISE"}

                                    </h1>
                                    <button type="button" className="btn-close" onClick={handleCloseModal}></button>
                                </div>
                                <div className="modal-body">

                                    <div className="text-center py-4">

                                        <div className="mb-4 p-3 rounded" style={{ backgroundColor: "#8FC5CF" }}>
                                            <p className="mb-0 fs-5">
                                                Deseja alterar a peça para {selectedItem.gsA_Status == "Em analise" ? "RETRABALHO" : "EM ANALISE"}?
                                            </p>
                                        </div>

                                        <table className="table table-bordered mx-auto" style={{ maxWidth: "550px" }}>
                                            <tbody>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ width: "40%", padding: "16px" }}>
                                                        Ordem
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.gsA_Ordem}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                        Defeito
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {/* {selectedItem.defeito?.defeito_Descricao.toUpperCase()} */}
                                                        <select value={defect} className="form-select" aria-label="Default select example"
                                                            onChange={(e) => setDefect(e.target.value)}
                                                        >

                                                            <option value="">Selecionar defeito...</option>
                                                            {defects.map(defect2 => (
                                                                <option key={defect2.defeito_Key} value={defect2.defeito_Key}>
                                                                    {defect2.defeito_Descricao}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ width: "40%", padding: "16px" }}>
                                                        Peça
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.informacoes?.ordem_Part_Short}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }} >
                                                        Veículo
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }} >
                                                        {selectedItem.informacoes?.ordem_VehDesc}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                        Setor
                                                    </td>
                                                    <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                        {selectedItem.informacoes?.ordem_SetAtual}
                                                    </td>
                                                </tr>
                                                {
                                                    selectedItem.gsA_Status == "Em analise" &&
                                                    (
                                                        <>
                                                            <tr>
                                                                <td className="fw-bold fs-5 align-middle" style={{ padding: "16px" }}>
                                                                    Setor de Retrabalho
                                                                </td>
                                                                <td className="fs-5 align-middle" style={{ padding: "16px" }}>
                                                                    <div className="w-100 mt-3 h-10">

                                                                        <select value={sector} className="form-select" aria-label="Default select example"
                                                                            onChange={(e) => setSector(e.target.value)}
                                                                        >
                                                                            <option value="" selected>Selecionar setor...</option>
                                                                            {sectors.map(sector2 => {
                                                                                return (
                                                                                    <option key={sector2.setor_Key} value={sector2.setor_Key}>
                                                                                        {sector2.setor_Descricao}
                                                                                    </option>
                                                                                );
                                                                            })}
                                                                        </select>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                                        Fechar
                                    </button>
                                    <button onClick={(() => reworkGSA(selectedItem))} type="button" className="btn btn-primary">
                                        Confirmar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div >
                )
            }

            {showApproveModal && selectedItem &&
                (
                    <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                        <div className="modal-dialog modal-dialog-centered">
                            <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px', backgroundColor: '#f5f5f5' }}>
                                <div className="modal-body text-center py-5 px-4">

                                    <h2 className="fw-bold mb-4" style={{ color: '#333', fontSize: '1.8rem' }}>
                                        Liberar Peça?
                                    </h2>

                                    <p className="mb-4" style={{ color: '#666', fontSize: '1.1rem', lineHeight: '1.6' }}>
                                        O apontamento deverá ser realizado <strong>MANUALMENTE</strong>.
                                    </p>

                                    <div className="d-flex justify-content-center gap-3 mt-4">

                                        <button type="button" className="btn btn-secondary" onClick={(() => handleCloseApproveModal())}>
                                            Fechar
                                        </button>
                                        <button onClick={(() => approveGSA(selectedItem))} type="button" className="btn btn-success">
                                            Confirmar
                                        </button>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )
            }

            {showReprocessoModal && selectedItem && (
                <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px', backgroundColor: '#f5f5f5' }}>
                            <div className="modal-body text-center py-5 px-4">
                                <h2 className="fw-bold mb-4" style={{ color: '#333', fontSize: '1.6rem' }}>
                                    Confirmar Reprocesso?
                                </h2>
                                <p className="mb-4" style={{ color: '#666', fontSize: '1.05rem', lineHeight: '1.6' }}>
                                    Deseja confirmar o reprocesso da ordem <strong>{selectedItem.gsA_Ordem}</strong>?
                                </p>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <button type="button" className="btn btn-secondary" onClick={() => { setShowReprocessoModal(false); setSelectedItem(null); }}>
                                        Não
                                    </button>
                                    <button type="button" className="btn btn-success" onClick={() => confirmReprocesso(selectedItem)}>
                                        Confirmar Reprocesso
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showReprocessoToAnalysisModal && selectedItem && (
                <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: '12px', backgroundColor: '#f5f5f5' }}>
                            <div className="modal-body text-center py-5 px-4">
                                <h2 className="fw-bold mb-4" style={{ color: '#333', fontSize: '1.6rem' }}>
                                    Voltar para Em análise?
                                </h2>
                                <p className="mb-4" style={{ color: '#666', fontSize: '1.05rem', lineHeight: '1.6' }}>
                                    Deseja retornar a ordem <strong>{selectedItem.gsA_Ordem}</strong> para <strong>Em análise</strong>?
                                    O apontamento de reprocesso existente será <strong>excluído</strong>.
                                </p>
                                <div className="d-flex justify-content-center gap-3 mt-4">
                                    <button type="button" className="btn btn-secondary"
                                        disabled={reprocessoToAnalysisLoading}
                                        onClick={() => { setShowReprocessoToAnalysisModal(false); setSelectedItem(null); }}>
                                        Não
                                    </button>
                                    <button type="button" className="btn btn-primary"
                                        disabled={reprocessoToAnalysisLoading}
                                        onClick={() => reprocessoToAnalysis(selectedItem)}>
                                        {reprocessoToAnalysisLoading ? (
                                            <>
                                                <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                                                Processando...
                                            </>
                                        ) : "Confirmar"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {showMoldeModal && selectedItem && (
                <div className="modal fade show d-block" tabIndex={-1} style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
                    <div className="modal-dialog modal-xl modal-dialog-centered">
                        <div className="modal-content border-0 shadow-lg" style={{ borderRadius: "10px", overflow: "hidden" }}>
                            <div className="modal-header" style={{ backgroundColor: "#fff", borderBottom: "2px solid #dee2e6", padding: "16px 24px" }}>
                                <h5 className="modal-title fw-bold text-danger" style={{ fontSize: "1.2rem", letterSpacing: "0.3px" }}>
                                    Ordem {selectedItem.gsA_Ordem} — Molde {selectedItem.molde_Lote}
                                </h5>
                                <button type="button" className="btn-close" onClick={handleCloseMoldeModal}></button>
                            </div>
                            <div className="modal-body" style={{ padding: "20px 24px", backgroundColor: "#fafafa" }}>
                                <p className="text-muted mb-3" style={{ fontSize: "0.9rem" }}>
                                    Apontamentos registrados para este molde:
                                </p>
                                <div className="table-responsive mb-4">
                                    <table className="table table-bordered table-hover mb-0" style={{ fontSize: "0.92rem", backgroundColor: "#fff" }}>
                                        <thead style={{ backgroundColor: "#343a40", color: "#fff" }}>
                                            <tr>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Ordem</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Tipo Notif</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Setor</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Veículo</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Projeto</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Tipo Defeito</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Causa</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Origem</th>
                                                <th className="fw-semibold" style={{ padding: "12px 16px", whiteSpace: "nowrap", verticalAlign: "middle", letterSpacing: "0.4px" }}>Data Apontamento</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {moldeData.length > 0 ? (
                                                [...moldeData]
                                                    .sort((a, b) => {
                                                        const dateA = a.dt_Hr_Apont ? new Date(a.dt_Hr_Apont).getTime() : 0;
                                                        const dateB = b.dt_Hr_Apont ? new Date(b.dt_Hr_Apont).getTime() : 0;
                                                        return dateB - dateA;
                                                    })
                                                    .map((item, idx) => (
                                                        <tr key={idx} style={{ backgroundColor: idx % 2 === 0 ? "#fff" : "#f8f9fa" }}>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#212529", fontWeight: 500 }}>
                                                                {item.ordem ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle" }}>
                                                                {item.tipo_Notificacao ? (
                                                                    <span className={`badge fs-6 px-3 py-2 ${item.tipo_Notificacao === "REFUGO"
                                                                        ? "bg-danger"
                                                                        : item.tipo_Notificacao === "REPROCESSO"
                                                                            ? "bg-warning text-dark"
                                                                            : "bg-success"
                                                                        }`} style={{ letterSpacing: "0.5px" }}>
                                                                        {item.tipo_Notificacao}
                                                                    </span>
                                                                ) : <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.setor?.trim() || <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.veiculo ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.projeto ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.tipo_Defeito ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.causa ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057" }}>
                                                                {item.origem ?? <span className="text-muted">—</span>}
                                                            </td>
                                                            <td style={{ padding: "11px 16px", verticalAlign: "middle", color: "#495057", whiteSpace: "nowrap" }}>
                                                                {item.dt_Hr_Apont
                                                                    ? new Date(item.dt_Hr_Apont).toLocaleString("pt-BR")
                                                                    : <span className="text-muted">—</span>}
                                                            </td>
                                                        </tr>
                                                    ))
                                            ) : (
                                                <tr>
                                                    <td colSpan={9} className="text-center text-muted py-4" style={{ fontSize: "0.95rem" }}>
                                                        Nenhum apontamento encontrado.
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>

                                <div className="p-3 rounded" style={{ backgroundColor: "#fff", border: "1px solid #dee2e6" }}>
                                    <label
                                        htmlFor="moldeMotivoSelect"
                                        className="form-label fw-bold mb-2"
                                        style={{ fontSize: "0.95rem", color: "#212529" }}
                                    >
                                        Motivo da Pendência <span className="text-danger">*</span>
                                    </label>
                                    <select
                                        id="moldeMotivoSelect"
                                        className="form-select"
                                        value={moldeMotivo}
                                        onChange={(e) => setMoldeMotivo(e.target.value)}
                                        style={{ fontSize: "0.95rem", padding: "10px 12px" }}
                                    >
                                        <option value="">Selecionar motivo...</option>
                                        {moldeMotivos.map((motivo) => (
                                            <option key={motivo.molde_Pend_Mot_Key} value={motivo.molde_Pend_Mot_Key}>
                                                {motivo.molde_Pend_Mot_Descricao}
                                            </option>
                                        ))}
                                    </select>
                                    {!moldeMotivo && (
                                        <small className="text-muted d-block mt-2" style={{ fontSize: "0.82rem" }}>
                                            Selecione um motivo para habilitar enviar o molde a ferramentaria.
                                        </small>
                                    )}
                                </div>
                            </div>
                            <div className="modal-footer" style={{ backgroundColor: "#fff", borderTop: "2px solid #dee2e6", padding: "12px 24px" }}>
                                <button type="button" className="btn btn-secondary" onClick={handleCloseMoldeModal}>
                                    Fechar
                                </button>
                                <button
                                    type="button"
                                    className="btn btn-danger"
                                    disabled={!moldeMotivo || moldeLoading}
                                    onClick={disableMolde}
                                >
                                    {moldeLoading ? "Desativando..." : "Enviar para Ferramentaria"}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <TableContainer
                className="mt-3"
                component={Paper}
            >
                <div className="p-3">
                    <input
                        type="text"
                        className="form-control"
                        placeholder="Filtrar por Ordem..."
                        value={ordemFilter}
                        onChange={(e) => setOrdemFilter(e.target.value)}
                        style={{ maxWidth: "300px" }}
                    />
                </div>
                <div className="mb-4">
                    <div className="d-flex align-items-center mb-3 p-3 rounded shadow-sm" style={{
                        backgroundColor: "#e3f2fd",
                        borderLeft: "5px solid #2196f3"
                    }}>
                        <i className="bi bi-hourglass-split fs-4 me-3" style={{ color: "#1976d2" }}></i>
                        <h4 className="mb-0 fw-bold" style={{ color: "#1565c0" }}>Em Análise</h4>
                    </div>
                    <TableContainer component={Paper} className="shadow-sm">
                        {tableList("Em analise")}
                    </TableContainer>
                </div>

                <div className="mb-4">
                    <div className="d-flex align-items-center mb-3 p-3 rounded shadow-sm" style={{
                        backgroundColor: "#ffebee",
                        borderLeft: "5px solid #f44336"
                    }}>
                        <i className="bi bi-tools fs-4 me-3" style={{ color: "#d32f2f" }}></i>
                        <h4 className="mb-0 fw-bold" style={{ color: "#c62828" }}>Reprocesso</h4>
                    </div>
                    <TableContainer component={Paper} className="shadow-sm">
                        {tableList("REPROCESSO")}
                    </TableContainer>
                </div>

                <div className="mb-4">
                    <div className="d-flex align-items-center mb-3 p-3 rounded shadow-sm" style={{
                        backgroundColor: "#fff3e0",
                        borderLeft: "5px solid #ff9800"
                    }}>
                        <i className="bi bi-tools fs-4 me-3" style={{ color: "#f57c00" }}></i>
                        <h4 className="mb-0 fw-bold" style={{ color: "#e65100" }}>Retrabalho</h4>
                    </div>
                    <TableContainer component={Paper} className="shadow-sm">
                        {tableList("RETRABALHO")}
                    </TableContainer>
                </div>
            </TableContainer>
        </>
    );
}

export default GSAList;
